<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/Layout/Header/LayoutHeaderWishlist.vue
// changes:
// change size of wishlist icon

const { count: wishlistCount } = useWishlist();
</script>

<template>
    <LocaleLink
        to="/wishlist"
        class="relative"
    >
        
<FormKitLazyProvider config-file="true">
<FormKitIcon
            class="block w-5 *:fill-none"
            icon="heart-header"
        />
        <UtilityPill
            :number="wishlistCount"
            class="absolute bottom-2.5 left-3"
        />
</FormKitLazyProvider>

    </LocaleLink>
</template>
